export default __webpack_public_path__ + "static/media/Responses@32.f23885e4.svg";